<app-notification-banner></app-notification-banner> <router-outlet></router-outlet>
